/* global google */
import React from 'react';

class GoogleLocationTextInput extends React.Component {
    handlePlace(ac) {
        var place = ac.getPlace();
        this.props.callBack(place);
    }

    componentDidMount() {
        var input = React.findDOMNode(this.refs[this.props.reference]);
        var options = {
            types: [this.props.types],
            componentRestrictions: {country: DJ_CONST.LOCALE_CONF.country}
        };
        var autocomplete = new google.maps.places.Autocomplete(input, options);
        google.maps.event.addListener(autocomplete, 'place_changed', function() {
            this.handlePlace(autocomplete);
        }.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value === null) {
            this.refs[nextProps.reference].getDOMNode().value = '';
        }
    }

    onBlur() {
        const path = this.props.path || 'address';
        if (this.props.onBlur) {
            this.props.onBlur(path);
        }
    }

    render() {
        // setup our classes
        const classes = `${this.props.className}`;
        const disabled = this.props.disabled;
        const title = this.props.title || 'Address';
        return (
            <label className="form-control form-control-text">
                <div className="form-group">
                    <h3 className="label-title">{title}</h3>
                    <input disabled={disabled} type="text" onBlur={this.onBlur.bind(this)} onChange={this.props.onChange} ref={this.props.reference} placeholder={this.props.placeholder} defaultValue={this.props.value} className={classes} />
                    {this.props.error ? <span className="help-block error-block">{this.props.error}</span> : null}
                </div>
            </label>
        );
    }
}

GoogleLocationTextInput.propTypes = {
    reference: React.PropTypes.string,
    className: React.PropTypes.string,
    placeholder: React.PropTypes.string,
    callBack: React.PropTypes.func.isRequired,
    types: React.PropTypes.string
};

export default GoogleLocationTextInput;



/** WEBPACK FOOTER **
 ** ./app/src/components/Form_widgets/GoogleLocationInput.js
 **/